import { MoreOutlined } from '@ant-design/icons'
import { Button, Dropdown, Menu, Tag } from 'antd'

import { buildSearchFilterProps, sortNumericColumn, sortStringColumn } from '../../components/tables/utils'
import { KycCustomer } from './models'

interface Props {
  onUpdate: (customer: KycCustomer) => void
}

const renderActionsMenu = ({ onUpdate }: Props) => (customer: KycCustomer) => {
    const menu = (
      <Menu key={customer.id}>
        <Menu.Item key="updateKyc" onClick={() => onUpdate(customer)}>
          Update Customer
        </Menu.Item>
      </Menu>
    )

    return (
      <Dropdown placement="bottomRight" overlay={menu}>
        <Button icon={<MoreOutlined />} />
      </Dropdown>
    )
  }

export const buildKycCustomersTableColumns = ({ onUpdate }: Props) => [
  {
    title: 'Id',
    dataIndex: 'id',
    sorter: sortNumericColumn({ dataIndex: 'id' }),
    ...buildSearchFilterProps({ dataIndex: 'id' }),
  },
  {
    title: 'Issuer',
    dataIndex: 'issuerName',
    sorter: sortStringColumn({ dataIndex: 'issuerName' }),
    ...buildSearchFilterProps({ dataIndex: 'issuerName' }),
  },
  {
    title: 'Tenant',
    dataIndex: 'tenantName',
    sorter: sortStringColumn({ dataIndex: 'tenantName' }),
    ...buildSearchFilterProps({ dataIndex: 'tenantName' }),
  },
  {
    title: 'Customer ID',
    dataIndex: 'customerCode',
    sorter: sortStringColumn({ dataIndex: 'customerCode' }),
    ...buildSearchFilterProps({ dataIndex: 'customerCode' }),
  },
  {
    title: 'Customer Type',
    dataIndex: 'customerType',
    sorter: sortStringColumn({ dataIndex: 'customerType' }),
    ...buildSearchFilterProps({ dataIndex: 'customerType' }),
    render: (customerType) => (
      <Tag color={customerType === 'bespoke' ? 'blue': ''}>{customerType}</Tag>
    )
  },
  { title: '', render: renderActionsMenu({ onUpdate }) },
]
